import Glide from "@glidejs/glide";

document
  .querySelectorAll('.glide-testimonial')
  .forEach((slider) => {
    if (slider) {
      const CustomLength = function(Glide, Components, Events) {
        return {
          mount () {
            Events.emit('slider.length', Components.Sizes.length)
          }
        }
      }
    
      const config = {
        perView: 1,
        gap:0,
        rewind: false,
        type: 'slider',
        autoheight: true,
        animationDuration: 1000
      };
      let glide = new Glide(slider, config)
    
      glide.on('slider.length', (length) => {
        if(length <= 1){
          glide.disable()
        }
      })
      
      glide.mount({
        CustomLength
      })
    }
  } ) 